<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "app-view",
  watch: {
    "$i18n.locale": {
      handler() {
        document.title = this.$tc("websiteTitle");
        document.documentElement.setAttribute("lang", this.$i18n.locale);
      },
      immediate: true,
    },
  },
  mounted() {
    this.$store.dispatch("App/setSnackbarMessageForUserRole");
  },
};
</script>
